export type TAudioContextLatencyCategory = 'balanced' | 'interactive' | 'playback';
